<template>
  <div id="InitiaExpert" v-loading="loading" element-loading-text="拼命加载中">
    <h3>预览模式</h3>
    <div class="selfBoxs">
      <initiaItem :isEdit="true" style="padding-right: 10px; flex: 1" :data="examinationInfo.questionBankList"></initiaItem>
      <div class="catalogue"></div>
      <div class="catalogue" style="position: fixed; right: 20px">
        <h3 style="width: 100%; margin-bottom: 10px">目录</h3>
        <div @click="handleCatalog(item)" :class="item.class" class="box" v-for="(item, index) in catalogue" :key="`${index}a1`">
          {{ item.index }}
        </div>
      </div>
    </div>
    <el-form @submit.native.prevent v-if="examinationInfo.isChiefReviewer == 1" style="margin: 30px 0" :model="form" :rules="rules" ref="ruleForm">
      <h3 style="margin: 25px 0">主评审详情</h3>
      <el-form-item label="主审专家点评">
        {{ form.expertOpinion }}
      </el-form-item>
      <el-form-item label="佐证图片">
        <div class="suppBox">
          <div @click="handleViewer(form, todex)" class="suppPicture" v-for="(pic, todex) in form.expertPicture" :key="`${todex}a`">
            <img :src="pic" alt="" />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="附件项：">
        <div v-if="form.expertAttachments&&form.expertAttachments.length" style="display: table-caption;">
          <el-button v-for="(file, f) in JSON.parse(form.expertAttachments)" :key="`${f}f`" type="text"
            @click.stop="handleFileViewing(file)">{{ file.name }}</el-button>
        </div>
      </el-form-item>
    </el-form>
    <div class="expertSignature">
      <!-- <h3>专家签名</h3>
      <img class="imgSig" :src="signature" alt="" /> -->
    </div>

    <div class="btnGurop">
      <el-button @click="common.returnBtn"><i class="el-icon-arrow-left"></i></el-button>
      <el-button :loading="btnLoading" type="primary" @click="successAve">确认提交</el-button>
    </div>
    <!-- 预览组件 -->
    <PreviewFile ref="previewFile"></PreviewFile>
  </div>
</template>

<script>
import moment from 'moment';
import initiaItem from './InitiaExperttem/initia_Item.vue';
import PreviewFile from "../../components/file-preview.vue"
export default {
  name: 'InitiaExpert',
  components: { initiaItem, PreviewFile },
  data() {
    return {
      examinationInfo: {},
      receiverSignFlag: true,
      expertId: this.$route.query.expertId, // 自评 id
      selfId: this.$route.query.selfId,
      loading: true,
      btnLoading: false,
      signature: '', // 签名 url
      isChiefReviewer: '', // 是否是主评审
      dialogFormVisible: false,
      uploadUrl: `${process.env.BASE_URL}api/file/upload`,
      form: {
        expertOpinion: '',
        expertPicture: [],
      },
      rules: {
        expertOpinion: [{ required: true, message: '请输入主审专家点评', trigger: 'blur' }],
        expertPicture: [{ required: true, message: '请上传佐证图片', trigger: 'blur' }],
      },
      catalogue: [],
      defaultExpansion: [], // 默认折叠展开的id
    };
  },
  watch: {
    examinationInfo: {
      handler(newVal, oldVal) {
        this.catalogue = [];
        this.filterByTier(newVal.questionBankList);
      },
      deep: true,
    },
  },
  created() {
    this.getExaminationInfo();
    this.getChiefReviewerInfo();
    this.getSignature();
  },
  mounted() { },
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
  },
  methods: {
    moment,
    // 获取详情回显内容
    getExaminationInfo() {
      this.$axios.post('api/review/expertInfo', { expertId: this.expertId }).then((res) => {
        if (res.data.code == 200) {
          this.loading = false;
          this.examinationInfo = res.data.data;
          this.isChiefReviewer = res.data.isChiefReviewer;
          /**
           * 将 里面的 图片字符串转成数组
           */
          this.filterData(this.examinationInfo.questionBankList, true);
          this.catalogue = [];
          this.filterByTier(this.examinationInfo.questionBankList);
          this.recursionFun(this.examinationInfo.questionBankList);
        }
      });
    },
    // 获取详情回显内容
    getSignature() {
      this.$axios.post('api/review/getSignature', { selfId: this.selfId }).then((res) => {
        if (res.data.code == 200) {
          this.signature = res.data.signature;
        }
      });
    },
    successAve() {
      // 1、先判断有无签名
      // if (!this.signature) {
      //   this.$message({
      //     type: 'info',
      //     message: '请返回填写签名',
      //   });
      //   return;
      // }
      this.httpsSave(2);
    },
    // 获取 主评审详情
    getChiefReviewerInfo() {
      this.$axios.post('api/review/chiefReviewerInfo', { selfId: this.selfId }).then((res) => {
        if (res.data.code == 200) {
          this.form.expertOpinion = res.data.expertOpinion;
          this.form.expertPicture = res.data.expertPicture ? res.data.expertPicture.split(',') : [];
        }
      });
    },

    // 保存 请求
    httpsSave(status, save) {
      /**
       * copy 一份，避免影响原有数据
       * 将 里面的 图片数组转成字符串
       */
      this.btnLoading = true;
      let pandms = JSON.parse(JSON.stringify(this.examinationInfo));
      console.log('🚀 ~ pandms:', pandms);
      this.filterData(pandms.questionBankList, false);
      this.$axios.post(`api/review/startReview?status=${status}`, pandms).then((res) => {
        if (res.data.code == 200) {
          this.btnLoading = false;
          if (save) return;
          this.$message({
            message: `${status == 1 ? '暂存' : '提交'}成功`,
            type: 'success',
            offset: 80,
          });
          this.$router.push({
            path: '/expertAssess',
          });
        } else {
          this.btnLoading = false;
          this.$message({
            message: `${status == 1 ? '暂存' : '提交'}失败${res.data.msg}`,
            type: 'error',
            offset: 80,
          });
        }
      });
    },
    filterData(data, type) {
      if (data && data.length) {
        try {
          data.forEach((e) => {
            if (type) {
              e.expertPicture = e.expertPicture ? e.expertPicture.split(',') : [];
              e.picture = e.picture ? e.picture.split(',') : [];
            } else {
              e.expertPicture = e.expertPicture ? e.expertPicture.join(',') : '';
              e.picture = e.picture ? e.picture.join(',') : '';
            }
            this.filterData(e.questionBankList, type);
          });
        } catch (error) {
          this.btnLoading = false;
          this.$message({
            message: `提交失败'`,
            type: 'error',
            offset: 80,
          });
        }
      }
    },

    BoxLayout() {
      this.$nextTick(() => {
        let lists = document.querySelectorAll('.suppBox');
        if (lists && lists.length) {
          lists.forEach((lis) => {
            const boxLay = new this.DynamicBoxLayout(lis, '.suppPicture', 80);
            boxLay.boxes.forEach((box) => {
              if (box) {
                box.style.height = box.style.width;
              }
            });
          });
        }
      });
    },
    // 查看佐证图片
    handleViewer(item, key) {
      this.$viewerApi({
        images: item.expertPicture,
        options: {
          initialViewIndex: key,
        },
      });
    },

    handleCatalog(item) {
      console.log('🚀 ~ item:', item.index);
      this.handDfaultFold(item.index);
      this.$nextTick(() => {
        let element = document.getElementById(`title${item.index}`);
        element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      });
    },
    // 计算 序号
    filterByTier(data) {
      console.log('🚀 ~ data:', data);
      let that = this;
      function traverse(arr, parentIndex) {
        arr.forEach((obj, index) => {
          let currentIndex = '';
          if (obj.tier == 4) {
            if (obj.expertScore > 0) {
              that.$set(obj, 'class', 'complets');
            }
            that.catalogue.push(obj);
          }
          currentIndex = parentIndex ? `${parentIndex}.${index + 1}` : `${index + 1}`;
          that.$set(obj, 'index', currentIndex);
          // 默认展开第一层
          if (obj.tier == 2) {
            that.defaultExpansion.push(obj.id);
          }
          if (obj.questionBankList) {
            traverse(obj.questionBankList, currentIndex);
          }
        });
      }
      traverse(data);
    },
    handDfaultFold(index) {
      diguiFold(this, this.examinationInfo.questionBankList);
      function diguiFold(that, arr) {
        if (arr && arr.length) {
          arr.forEach((e) => {
            that.$set(e, 'isFold', false);
            diguiFold(that, e.questionBankList);
          });
        }
      }
    },
    recursionFun(arr) {
      if (arr && arr.length) {
        arr.forEach((e) => {
          if (this.defaultExpansion.includes(e.id)) {
            this.$set(e, 'isFold', false);
          } else {
            this.$set(e, 'isFold', true);
          }
          this.recursionFun(e.questionBankList);
        });
      }
    },
    // 预览
    handleFileViewing(file) {
      this.$refs.previewFile.openDrawer([file]);
    },
  },
};
</script>

<style lang="less" scoped>
#InitiaExpert {
  padding-bottom: 0 !important;
}
.expertSignature {
  margin: 20px 0 70px 0;
  .boxSig,
  .imgSig {
    margin: 10px;
    width: 220px;
    height: 80px;
    cursor: pointer;
    border-radius: 4px;
    background-color: rgba(249, 249, 249, 1);
    border: 1px solid rgba(187, 187, 187, 1);
  }
  // .imgSig{

  // }
  .TextSig {
    font-size: 14px;
    margin: 10px;
    cursor: pointer;
  }
}
.btnGurop {
  // width: auto;
  bottom: 0;
  position: fixed;
  display: flex;
  height: 50px;
  align-items: center;
  background-color: #fff;
}
.suppBox {
  display: flex;
  flex-wrap: wrap;
  .suppPicture {
    margin: 0 10px 10px 0;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .picDel {
      position: absolute;
      right: 4px;
      top: 4px;
      font-size: 22px;
      color: rgba(255, 0, 0, 0.735);
      cursor: pointer;
    }
  }
}
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin: 0 10px 10px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / 1;
  /deep/ .el-upload {
    width: 100%;
    height: 100%;
  }
  .avatar {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    display: block;
    font-size: 38px;
    color: #d9d9d9;
  }
}
.selfBoxs {
  display: flex;
  .catalogue {
    width: 230px;
    min-width: 230px;
    max-width: 230px;
    padding-left: 10px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    .box {
      cursor: pointer;
      width: 45px;
      height: 30px;
      font-size: 14px;
      border: 1px solid #ccc;
      margin: 0 8px 8px 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .complets {
      border: 1px solid #015d14;
      background-color: #198e3027;
    }
  }
}
</style>

<style lang="less" scoped>
/* PC端样式 */
@media only screen and (min-width: calc(700px + 1px)) {
}

/* 移动端样式 */
@media only screen and (max-width: 700px) {
  /deep/.el-dialog {
    width: 80%;
  }
  .catalogue {
    display: none !important;
  }
}
</style>
